import React from 'react';

/**
 * Persistent demo-mode banner.
 *
 * Renders only when the backend reports demo_mode, so a screenshot of the demo
 * can never be mistaken for real client information.
 */
const DemoBanner = ({ visible }) => {
  if (!visible) return null;

  return (
    <div
      role="status"
      className="w-full shrink-0 bg-amber-500 text-amber-950 text-center text-xs font-semibold tracking-wide py-1.5 px-3"
    >
      DEMO DATA - NOT REAL CLIENT INFORMATION
    </div>
  );
};

export default DemoBanner;
